module.exports = __webpack_public_path__ + "static/media/No_Agreements.72b2a947.svg";